import React, { useState, useEffect, useContext } from 'react'
import { FirebaseContext } from '../components/Firebase'
import {
    onSnapshot,
    collection,
    query,
  } from "firebase/firestore"

const defaultState = {
  subscription: () => ('')
}
export const SubscriptionContext = React.createContext(defaultState)

export const SubscriptionProvider = (props) => {
  const { firebase, user } = useContext(FirebaseContext)
  const [subscription, setSubscription] = useState([])

  // let isMounted = true

  // useEffect(() => {
  //   return () => {
  //     isMounted = false
  //   }
  // }, [])

  // console.log(user)
    
  useEffect(() => {
    if (user && user.username && firebase && firebase.db) {
      const q = query(collection(firebase.db, 'users', user.organizationId, 'subscriptions'));
      
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        try {
          querySnapshot.forEach((subscription) => {
            console.log(subscription);
            console.log('subscription', subscription.data());
            setSubscription({
              role: subscription.data().role,
              current_period_start: subscription.data().current_period_start.seconds,
              current_period_end: subscription.data().current_period_end.seconds,
              status: subscription.data().status,
            });
          });
        } catch (error) {
          console.error("Error processing subscription snapshot:", error);
        }
      });
  
      return () => {
        unsubscribe(); // Bereinigungsfunktion zum Abbestellen des Listeners
      };
    }
  }, [user, firebase]);
  
  
  return (
    <SubscriptionContext.Provider value={[subscription, setSubscription]}>
      {props.children}
    </SubscriptionContext.Provider>
  )
}
